var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("UploadCustomWithPreview", {
        ref: "uploadedFiles",
        attrs: {
          extraData: { object: "invoice_detail", objectId: _vm.newRecordId },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-right" },
        [
          +_vm.newQty
            ? _c("LoadingButton", {
                attrs: {
                  title: "Добавить препарат",
                  type: "button",
                  className: "btn btn-outline-success",
                  onClick: () => _vm.addNewDrug(),
                  loading: _vm.loading,
                  color: _vm.$constants.SUCCESS_COLOR,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }